import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../environments/environment";
import { PlanReviewComponent } from "../../v2/planes-reviews/plan-review/plan-review.component";
import { NotificationService } from "../../services/notification.service";
import { LocalService } from "../../services/local.service";
import { PromoService } from "../../services/promo.service";
import { AuthenticationService } from "../../services/authentication.service";
import { MenuService } from "../../services/menu.service";
import { User } from "../../models/user";
import { CartaRequest } from "../../interfaces/cartaRequest.model";
import { LocalRequest } from "../../interfaces/localRequest.model";
import { PromoRequest } from "../../interfaces/promoRequest.model";
import { Pagination } from "../../models/pagination";
import { Local } from "../../models/local";
import { Carta } from "../../models/carta";
import { Promo } from "../../models/promo";

@Component({
  selector: "app-full-layout",
  templateUrl: "./full.component.html",
  styleUrls: ["./full.component.scss"],
})
export class FullComponent implements OnInit {
  public color = "white";
  public showSettings = false;
  public showMinisidebar = false;
  public showDarktheme = false;
  public showRtl = false;
  public year: any;
  public user: User;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private menuService: MenuService,
    private authenticationService: AuthenticationService,
    private localService: LocalService,
    private notificationService: NotificationService,
    private promoService: PromoService
  ) {
    this.year = new Date().getFullYear();
  }

  ngOnInit() {
    this.user = this.authenticationService.currentUserValue.user;

    if (this.user && this.user.rolId !== environment.roleAdminId) {
      if (this.user.rolId === 4 || this.user.rolId === 6) {
        if (this.user.wizard) {
          this.router.navigate(["/customers"]);
        } else {
          this.planReview();
        }
      }
    }
  }

  public async planReview(): Promise<void> {
    const cartas: Array<Carta> = await this.checkCarta();
    const locales: Array<Local> = await this.checkLocal();
    const promosInApp: Array<Promo> = await this.checkPromoInApp();
    const promosQR: Array<Promo> = await this.checkPromoQR();

    if (
      cartas.length > this.user.plan.configuracion.cartaLimit ||
      locales.length > this.user.plan.configuracion.localLimit ||
      promosInApp.length > this.user.plan.configuracion.promoLimitInApp ||
      promosQR.length > this.user.plan.configuracion.promoLimitQr
    ) {
      const modalRef = this.modalService.open(PlanReviewComponent, {
        centered: true,
        windowClass: "newModal plan-review",
        backdrop: "static",
        keyboard: false,
      });
      modalRef.componentInstance.cartas = cartas;
      modalRef.componentInstance.locales = locales;
      modalRef.componentInstance.promosInApp = promosInApp;
      modalRef.componentInstance.promosQR = promosQR;
      modalRef.result.then(
        (result: any) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
    } else {
      this.router.navigate(["/stats/list"]);
    }
  }

  public async checkCarta(): Promise<Carta[]> {
    const cartaRequest: CartaRequest = new CartaRequest();

    cartaRequest.setActiva(true);
    cartaRequest.setClienteId(this.user.cliente ? this.user.cliente.id : null);

    return await this.menuService
      .index(cartaRequest)
      .toPromise()
      .then(
        (pagination: Pagination) => {
          return Promise.resolve(pagination.data);
        },
        (error: HttpErrorResponse) => {
          this.notificationService.error(
            this.translate.instant(
              "Ocurrió un error al consultar las cartas, vuelva a intentarlo. Si persiste pongase en contacto con desarrollo@unblockthecity.com y atenderemos su problema."
            )
          );

          return Promise.resolve([]);
        }
      );
  }

  public async checkLocal(): Promise<Local[]> {
    const localRequest: LocalRequest = new LocalRequest();

    localRequest.setActivo(true);
    localRequest.setClienteId(this.user.cliente ? this.user.cliente.id : null);

    return await this.localService
      .index(localRequest)
      .toPromise()
      .then(
        (pagination: Pagination) => {
          return pagination.data;
        },
        (error: HttpErrorResponse) => {
          this.notificationService.error(
            this.translate.instant(
              "Ocurrió un error al consultar los locales, vuelva a intentarlo. Si persiste pongase en contacto con desarrollo@unblockthecity.com y atenderemos su problema."
            )
          );

          return Promise.resolve([]);
        }
      );
  }

  public async checkPromoInApp(): Promise<Promo[]> {
    const promoRequest: PromoRequest = new PromoRequest();

    promoRequest.setActiva(true);
    promoRequest.setClienteId(this.user.cliente ? this.user.cliente.id : null);
    promoRequest.setType(0);

    return await this.promoService
      .index(promoRequest)
      .toPromise()
      .then(
        (pagination: Pagination) => {
          return pagination.data;
        },
        (error: HttpErrorResponse) => {
          this.notificationService.error(
            this.translate.instant(
              "Ocurrió un error al consultar las promociones, vuelva a intentarlo. Si persiste pongase en contacto con desarrollo@unblockthecity.com y atenderemos su problema."
            )
          );

          return [];
        }
      );
  }

  public async checkPromoQR(): Promise<Promo[]> {
    const promoRequest: PromoRequest = new PromoRequest();

    promoRequest.setActiva(true);
    promoRequest.setClienteId(this.user.cliente ? this.user.cliente.id : null);
    promoRequest.setType(1);

    return await this.promoService
      .index(promoRequest)
      .toPromise()
      .then(
        (pagination: Pagination) => {
          return Promise.resolve(pagination.data);
        },
        (error: HttpErrorResponse) => {
          this.notificationService.error(
            this.translate.instant(
              "Ocurrió un error al consultar las promociones, vuelva a intentarlo. Si persiste pongase en contacto con desarrollo@unblockthecity.com y atenderemos su problema."
            )
          );

          return Promise.resolve([]);
        }
      );
  }
}
